import { ENABLE_AUTO_MODAL_DISABLE_TEST_091624 } from "@faire/web-api/indigofair/settings/ENABLE_AUTO_MODAL_DISABLE_TEST_091624";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableAutoModalDisableTest = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_AUTO_MODAL_DISABLE_TEST_091624,
    false
  );
